import React, { useEffect, useState } from "react";
import { replace, useNavigate } from "react-router-dom";
import { forgotPassword } from "../../services/accountService";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [showError, setShowError] = useState("hidden");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await forgotPassword(email);
      navigate(`/reset-password?email=${email}`, {replace: true});
    }
    catch(e) {
      console.log(e)
      setShowError(() => "");
      setTimeout(() => {
        setShowError(() => "hidden");
      }, 5000);
      return;
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Forgot Password?
        </h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <h6 className="text-gray-500">
              A code will be sent to the email address if it is registered
            </h6>
          </div>
          <div>
            <h6 className={`text-red-800 ${showError}`}>
              there is a problem with sending the code to your email address
            </h6>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-800 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Send Code
          </button>
          <div>
            <h6>
              <a className="text-blue-800 cursor-pointer hover:underline" onClick={() => navigate('/')}>login</a>
            </h6>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
